import { configureStore } from "@reduxjs/toolkit";

// import productReducer from "./slice/AddProduct";
import ContactUs from "./slices/ContactUs";
import NewsLetter from "./slices/NewsLetter";
import blogSlice from "./slices/Blogs";
import productSlice from "./slices/Product";
import GlobalSearch from "./slices/GlobalSearch";
import UserLocation from "./slices/UserLocation";

const store = configureStore({
  reducer: {
    contact: ContactUs,
    newsLetter: NewsLetter,
    Blog: blogSlice,
    Product: productSlice,
    GlobalSearch: GlobalSearch,
    userLocation: UserLocation,
  },
});

export default store;
